/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Pick_Preset_PlaceholderInputs */

const en_explorer_info_batch_pick_preset_placeholder = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a preset…`)
};

const fr_explorer_info_batch_pick_preset_placeholder = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez un préréglage…`)
};

const de_explorer_info_batch_pick_preset_placeholder = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine Voreinstellung…`)
};

const it_explorer_info_batch_pick_preset_placeholder = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un'impostazione predefinita…`)
};

const ru_explorer_info_batch_pick_preset_placeholder = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите предустановленный параметр…`)
};

const es_explorer_info_batch_pick_preset_placeholder = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un ajuste preestablecido…`)
};

const zh_cn2_explorer_info_batch_pick_preset_placeholder = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择预设…`)
};

const ja_explorer_info_batch_pick_preset_placeholder = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを選択してください…`)
};

const hi_explorer_info_batch_pick_preset_placeholder = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक प्रीसेट चुनें…`)
};

const pt_pt2_explorer_info_batch_pick_preset_placeholder = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma predefinição…`)
};

/**
* | output |
* | --- |
* | "Select a preset…" |
*
* @param {Explorer_Info_Batch_Pick_Preset_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_pick_preset_placeholder = /** @type {((inputs?: Explorer_Info_Batch_Pick_Preset_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Pick_Preset_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_batch_pick_preset_placeholder(inputs)
	if (locale === "de") return de_explorer_info_batch_pick_preset_placeholder(inputs)
	if (locale === "it") return it_explorer_info_batch_pick_preset_placeholder(inputs)
	if (locale === "ru") return ru_explorer_info_batch_pick_preset_placeholder(inputs)
	if (locale === "es") return es_explorer_info_batch_pick_preset_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_batch_pick_preset_placeholder(inputs)
	if (locale === "ja") return ja_explorer_info_batch_pick_preset_placeholder(inputs)
	if (locale === "hi") return hi_explorer_info_batch_pick_preset_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_batch_pick_preset_placeholder(inputs)
	return en_explorer_info_batch_pick_preset_placeholder(inputs)
});